module.exports = __webpack_public_path__ + "img/search.0f843925.png";